export const getters = {
  systemDeadStocks: state => state.deadstocks
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/deadstocks/getters.js